/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ vekn: NonNullable<unknown> }} User_List_Copy_VeknInputs */



/**
* | output |
* | --- |
* | "Copy VEKN ID {vekn}" |
*
* @param {User_List_Copy_VeknInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_list_copy_vekn = /** @type {((inputs: User_List_Copy_VeknInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_List_Copy_VeknInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Copier l'ID VEKN ${i?.vekn}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Copiar el ID VEKN ${i?.vekn}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Copiar o ID VEKN ${i?.vekn}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Copia l'ID VEKN ${i?.vekn}`)
	return /** @type {LocalizedString} */ (`Copy VEKN ID ${i?.vekn}`)
});